/**
 * Where the API lives, read off the host this bundle was served from.
 *
 * The API is the `api.` sibling of our own domain, and the rule has to hold for **every**
 * host the bundle can be served from, not just `app.`: this same build answers on the
 * apex (`heyup.ai`) and on `www.`, because one CloudFront distribution carries several
 * aliases. Substituting `app.` → `api.` left those two pointing the API at the *site* —
 * every call then landed on the CDN, which answers a preflight with an S3 error document
 * and no CORS header, so the browser reports it as a CORS failure and the real cause (a
 * request that never reached the API) stays hidden.
 *
 * The substitution was also unanchored, so a host like `myapp.heyup.ai` became
 * `myapi.heyup.ai`. Both are the same mistake: matching a *shape* where a leading label
 * was meant.
 */
const getServerUrl = (): string => {
  const { protocol, hostname } = document.location;

  // A front-end running `npm run dev` talks to the API on the same machine.
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:2998";
  }

  const bare = hostname.replace(/^(app|www)\./, "");
  return `${protocol}//${bare.startsWith("api.") ? bare : `api.${bare}`}`;
};

declare const __BUILD_TIME__: string;

const Env = {
  server: getServerUrl(),
  version: "1.6.9",
  buildTime:
    typeof __BUILD_TIME__ !== "undefined"
      ? __BUILD_TIME__
      : Date.now().toString(),
};

export default Env;
